import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastMessage {
  id: string;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private messages = new BehaviorSubject<ToastMessage[]>([]);
  public messages$ = this.messages.asObservable();

  showSuccess(message: string, duration: number = 3000): void {
    this.showMessage(message, 'success', duration);
  }

  showError(message: string, duration: number = 5000): void {
    this.showMessage(message, 'error', duration);
  }

  showWarning(message: string, duration: number = 4000): void {
    this.showMessage(message, 'warning', duration);
  }

  showInfo(message: string, duration: number = 3000): void {
    this.showMessage(message, 'info', duration);
  }

  private showMessage(message: string, type: ToastMessage['type'], duration: number): void {
    const id = Date.now().toString();
    const toast: ToastMessage = {
      id,
      message,
      type,
      duration
    };

    const currentMessages = this.messages.value;
    this.messages.next([...currentMessages, toast]);

    // Auto remove after duration
    if (duration > 0) {
      setTimeout(() => {
        this.removeMessage(id);
      }, duration);
    }
  }

  removeMessage(id: string): void {
    const currentMessages = this.messages.value;
    this.messages.next(currentMessages.filter(msg => msg.id !== id));
  }

  clearAll(): void {
    this.messages.next([]);
  }
} 